module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    },
    slot: "left"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("buttons.signin_with")) + " " + _vm._s(_vm.$t("buttons.email")))]), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doLogin(_vm.credentials, 'local')
      }
    }
  }, [_c('mt-field', {
    attrs: {
      "placeholder": _vm.$t('inputs.email'),
      "type": "email",
      "tabindex": "0",
      "autofocus": "",
      "required": ""
    },
    model: {
      value: (_vm.credentials.email),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "email", $$v)
      },
      expression: "credentials.email"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "placeholder": _vm.$t('inputs.password'),
      "type": "password",
      "tabindex": "1",
      "required": ""
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "password", $$v)
      },
      expression: "credentials.password"
    }
  }), _vm._v(" "), _c('mt-button', {
    staticClass: "primary",
    attrs: {
      "size": "large",
      "type": "primary",
      "tabindex": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("info.enter_to_account")))]), _vm._v(" "), _c('router-link', {
    staticClass: "forgot",
    attrs: {
      "to": {
        name: 'forgot',
        params: {
          email: _vm.credentials.email
        }
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("links.forgot_pass")) + "\n      ")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('img', {
    attrs: {
      "id": "logo",
      "src": require("../../../assets/images/logo.png"),
      "onerror": "this.onerror=null; this.src='logo.png'"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03bc5402!./src/app/pages/signin/index.html
// module id = 744
// module chunks = 18